
export const APP_ENUMS ={
  PREFIX_LOCAL_LANG: 'localLang',
  PREFIX_DEFAULT_LANGUAGE: 'fr',
  PREFIX_FR: 'fr',
  PREFIX_EN: 'en',
}
